/**
 * Camera view orientation.
 */
export var CameraViewOrientation;
(function (CameraViewOrientation) {
    CameraViewOrientation["FRONT"] = "front";
    CameraViewOrientation["BACK"] = "back";
    CameraViewOrientation["TOP"] = "top";
    CameraViewOrientation["BOTTOM"] = "bottom";
    CameraViewOrientation["LEFT"] = "left";
    CameraViewOrientation["RIGHT"] = "right";
})(CameraViewOrientation || (CameraViewOrientation = {}));
